import { render } from "./OldUploadTemplate.vue?vue&type=template&id=41e780d0"
import script from "./OldUploadTemplate.vue?vue&type=script&lang=js"
export * from "./OldUploadTemplate.vue?vue&type=script&lang=js"

import "./OldUploadTemplate.vue?vue&type=style&index=0&id=41e780d0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__